export default __webpack_public_path__ + "media/images/12-0d967db37d578e62481409eadaad8d85.jpg";